import React from 'react';
import { useAccordionButton } from 'react-bootstrap';
import { Button } from '../util/buttons';
const AccordionCustomToggle = _ref => {
  let {
    children,
    eventKey,
    open
  } = _ref;
  const decoratedOnClick = useAccordionButton(eventKey);
  return /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    icon: open ? 'chevron_right' : 'expand_more',
    onClick: decoratedOnClick,
    className: "ms-auto me-3"
  }, children);
};
export default AccordionCustomToggle;